import { lazy } from 'react';
import NotFound from 'pages/404';

const HomePage = lazy(() => import('pages/HomePage/index'));
const LiquidityPage = lazy(() => import('pages/LiquidityPage/index'));
const CreatePool = lazy(() => import('pages/LiquidityPage/Components/CreatePool'));
const LiquidityWithdraw = lazy(() => import('pages/LiquidityPage/Components/LiquidityWithdraw'));
const PoolsInfo = lazy(() => import('pages/InfoPage/index'));
const PoolDetail = lazy(() => import('pages/InfoPage/Components/PoolDetail'));
const StakingPage = lazy(() => import('pages/StakingSimplepage/index'));
const CEXOnRampPage = lazy(() => import('pages/CEXOnRampPage/index'));

const privateRoutes = [
    {
        path: '/',
        element: HomePage,
    },
    {
        path: '/liquidity',
        element: LiquidityPage,
    },
    {
        path: '/liquidity/addLiquidity',
        element: CreatePool,
    },
    {
        path: '/liquidity/remove',
        element: LiquidityWithdraw,
    },
    {
        path: '/pools',
        element: PoolsInfo,
    },
    {
        path: '/pools/poolsInfo',
        element: PoolDetail,
    },
    {
        path: '/staking',
        element: StakingPage,
    },
    {
        path: '/cexOnRamp',
        element: CEXOnRampPage,
    },
    {
        path: '*',
        element: NotFound,
    },
];

export default privateRoutes;
